var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',[_c('mHeaderNav')],1),_vm._v(" "),_c('div',[_c('el-row',{attrs:{"gutter":20}},[_c('router-view',{on:{"footer":_vm.footer}})],1)],1),_vm._v(" "),(_vm.footer_show)?_c('div',[_c('mFooterNav')],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-81ccc3c0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/m/com/mLayout.vue
// module id = null
// module chunks = 